<script lang="ts">
  import type { Snippet } from "svelte";

  let {
    name,
    options,
    option = null,
    group = $bindable(),
    required = false,
    vertical = true,
    error,
  }: {
    name: string;
    options: [any, string][];
    option?: Snippet<[any]>;
    group?: string;
    vertical?: boolean,
    required?: boolean;
    error?: string;
  } = $props();
  // NOTE: OfferStep is now the only component that uses vertical={false}.
  // Consult design/product before using vertical={false} anywhere new.
</script>

{#snippet basic(text)}<span>{text}</span>{/snippet}

<!-- items-start keeps label hit-boxes from having potentially multiple inches of whitespace -->
<div class="flex gap-4 {vertical ? "flex-col items-start" : "flex-row"}">
  {#each options as [label, value]}
    <label class={["flex flex-row gap-2", vertical ? "items-start" : "items-center"]}>
      <input
        type="radio"
        class="radio"
        class:input-error={!!error}
        {name}
        {value}
        bind:group={group}
        {required}
      />
      {@render (option || basic)(label)}
    </label>
  {/each}
</div>

{#if error}
  <div class="ui-error">{error}</div>
{/if}
